export default {
  memberRecord_00001: "特权会员开通记录",
}